/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BenchmarkStartResponse
 */
export interface BenchmarkStartResponse {
    /**
     * Unique session ID for this benchmark run
     * @type {string}
     * @memberof BenchmarkStartResponse
     */
    sessionId: string;
}

/**
 * Check if a given object implements the BenchmarkStartResponse interface.
 */
export function instanceOfBenchmarkStartResponse(value: object): value is BenchmarkStartResponse {
    if (!('sessionId' in value) || value['sessionId'] === undefined) return false;
    return true;
}

export function BenchmarkStartResponseFromJSON(json: any): BenchmarkStartResponse {
    return BenchmarkStartResponseFromJSONTyped(json, false);
}

export function BenchmarkStartResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BenchmarkStartResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'sessionId': json['sessionId'],
    };
}

export function BenchmarkStartResponseToJSON(value?: BenchmarkStartResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'sessionId': value['sessionId'],
    };
}

